import Vue from 'vue'
import store from '@/store'
import { url2localProtocol, imageCut } from '@/common/utils/util'

const loadImage = function (el, urls) {
  if (!urls.length) return
  let img = new Image()
  img.src = urls[0]
  img.onload = function () {
    el.appendChild(img)
  }
  img.onerror = function (err) {
    console.warn('Image load failed: ', err)
    loadImage(el, urls.slice(1))
  }
}
export default function initGlobalDirectives () {
  // v-auth 权限控制标签
  Vue.directive('auth', function (el, binding) {
    // 指令第一次绑定到元素时调用
    const { value } = binding
    if (!store.state.login.userInfo.feature_auth[value]) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
  })
  // gift 图床
  Vue.directive('image', function (el, binding) {
    let { value } = binding
    value = value.url || value
    let defaultCut = value.cutRatio || '240x240'
    let urls = [url2localProtocol(imageCut(value, defaultCut)), url2localProtocol(value)]
    loadImage(el, urls)
  })
  Vue.directive('img-error', function (el, binding) {
    let { value } = binding
    el.onerror = function () {
      // 如果加载地址为图床地址，则切换为原图地址
      if (el.src !== value) {
        el.src = value
      } else {
        el.style.display = 'none'
      }
    }
  })
}
